<template>
  <v-card>
    <v-card-title style="padding: 0">
      <v-toolbar color="transparent" density="compact">
        <template v-slot:append>
          <v-btn size="small" icon="mdi-close" @click="$emit('update:modelValue', false)"></v-btn>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-divider style="margin: 0" class="border-opacity-100"></v-divider>

    <v-card-text>
      <v-data-table v-if="!this.$vuetify.display.mobile" :headers="headers" :items="list" :hide-default-footer="true"
        :items-per-page="-1" :loading="loading">
        <template v-slot:item.text_mess="{ value }">
          <div class="v-htmlContent" v-html="value"></div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div style="min-width: 60px">
            <v-icon @click="editItem(item)" color="green-accent-4">
              mdi-pencil
            </v-icon>
            <v-icon @click="deleteItem(item)" color="red-accent-4" class="ml-2">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>

      <v-data-table v-else :items="list" :hide-default-footer="true" hide-default-header
        :items-per-page="-1" :loading="loading">
        <template v-slot:headers></template>
        <template v-slot:item="{ item }">
          <tr>
            <td>Текст</td>
            <td><span class="v-htmlContent" v-html="item.text_mess"></span></td>
          </tr>
          <tr>
            <td>Дата окончания</td>
            <td>{{ item.date_end }}</td>
          </tr>
          <tr>
            <td>Создатель</td>
            <td>{{ item.creator }}</td>
          </tr>
          <tr>
            <td>Доступен</td>
            <td>{{ item.type_mess }}</td>
          </tr>
          <tr>
            <td>Действия</td>
            <td>
              <div style="min-width: 60px">
                <v-icon @click="editItem(item)" color="green-accent-4">
                  mdi-pencil
                </v-icon>
                <v-icon @click="deleteItem(item)" color="red-accent-4" class="ml-2">
                  mdi-delete
                </v-icon>
              </div>
            </td>
          </tr>
          <v-divider style="margin: 0" class="border-opacity-100"></v-divider>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>


    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn text="Закрыть" @click="$emit('update:modelValue', false)"></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "announceArchive",
  props: {
    modelValue: {
      required: true,
    },
  },
  emits: ["update:modelValue", "editMessage"],
  data() {
    return {
      headers: [
        { title: "Текст", align: "start", key: "text_mess", sortable: false },
        { title: "Создано", align: "end", key: "date_create" },
        { title: "Дата окончания", align: "end", key: "date_end" },
        { title: "Создатель", align: "end", key: "creator" },
        { title: "Доступен", align: "end", key: "type_mess", sortable: false },
        { title: "Actions", key: "actions", sortable: false },
      ],
      list: [],
      loading: true,
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/psm_desktop2/getAllMessages"
      )
      .then((response) => {
        this.list = response.data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    editItem(item) {
      this.$emit('editMessage', item.id);
    },
    deleteItem(item) {
      this.loading = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/deleteMessage",
          new URLSearchParams({
            id: item.id,
          })
        )
        .then((response) => {
          this.list = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.v-htmlContent p{
  margin: 0;
}
</style>
